<script setup lang="ts">
import alertIcon from '@/assets/icons/white/attention.svg'
import AlertDialog from '@/components/AlertDialog.vue'
import { ref } from 'vue'

const props = defineProps<{ handleConfirm: () => void }>()

const isOpen = ref(false)

function open() {
  isOpen.value = true
}
function close() {
  isOpen.value = false
}
</script>

<template>
  <Button
    id="save-edit-corporative-account"
    color="grey-3"
    type="button"
    @click="open"
  >
    {{ $t('general.cancel') }}
  </Button>

  <AlertDialog
    :is-open="isOpen"
    :icon="alertIcon"
    color="alert"
    :text="$t('corporate.newRole.cancelDialogMessage')"
    :title="$t('general.advise')"
    class="d-flex flex-column text-body-2"
    style="min-width: 100%; padding-left: 2.5rem; padding-right: 2.5rem"
    @close="close"
  >
    <div class="d-flex" style="gap: 8px">
      <Button
        class="text-body-1 my-4"
        color="grey-3"
        style="min-height: 2.5rem; min-width: 10rem"
        @click="close"
      >
        {{ $t('general.back') }}
      </Button>
      <Button
        class="text-body-1 my-4"
        color="alert"
        style="min-height: 2.5rem; min-width: 10rem"
        @click="props.handleConfirm"
      >
        {{ $t('general.exit') }}
      </Button>
    </div>
  </AlertDialog>
</template>
